import * as React from 'react';

import { UserRole } from '@shared/types/user_role';

import { ROLES } from '@admin/config/roles';

export const Roles: React.FC<{
  show?: UserRole[];
  hide?: UserRole[];
}> = ({ show, hide, children }) => {
  if (show !== undefined && !show.some((role) => ROLES.has(role))) {
    return null;
  }
  if (hide !== undefined && hide.some((role) => ROLES.has(role))) {
    return null;
  }
  return <>{children}</>;
};
